import { useEffect } from "react";
import { Division, EmptyState, Heading, Icons, Paragraph } from "@ir/ui";
import { useNavigate, useParams } from "react-router";
import {
  getMasterDataSectionLabel,
  isMasterDataSection,
} from "./masterDataNav.config";
import { useMasterDataBrand } from "./MasterDataBrandContext";

export const MasterDataPlaceholderPage = () => {
  const navigate = useNavigate();
  const { section } = useParams<{ section?: string }>();
  const { organizationKey, brandKey, isBrandSelected } = useMasterDataBrand();

  useEffect(() => {
    if (!organizationKey || !brandKey) {
      return;
    }
    if (!isMasterDataSection(section)) {
      navigate(`/master-data/${organizationKey}/${brandKey}`, {
        replace: true,
      });
    }
  }, [brandKey, navigate, organizationKey, section]);

  if (!isBrandSelected || !isMasterDataSection(section)) {
    return null;
  }

  const title = getMasterDataSectionLabel(section) ?? section;

  return (
    <Division className="master-data-placeholder">
      <Heading level={6} className="text-grey-700 font-bold m-0 mb-1">
        {title}
      </Heading>
      <Paragraph className="text-grey-500 m-0 mb-3">
        Foundational data for the selected brand.
      </Paragraph>
      <EmptyState
        icon={Icons.Hourglass01}
        title="Coming soon"
        description={`${title} management will be available in a future release.`}
      />
    </Division>
  );
};
